module.exports = __webpack_public_path__ + "static/media/tr.121e8386.svg";